// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetCustomFieldCostCenterValuesQueryVariables = Types.Exact<{
  query: Types.CostCenterQueryModelInput;
  page: Types.PageModelInput;
}>;

export type GetCustomFieldCostCenterValuesQuery = {
  costCenters: {
    totalCount?: number | null;
    items?: Array<{ uid: string; name?: string | null; referenceId?: string | null } | null> | null;
  };
};

export const GetCustomFieldCostCenterValuesDocument = gql`
    query GetCustomFieldCostCenterValues($query: CostCenterQueryModelInput!, $page: PageModelInput!) {
  costCenters(query: $query, page: $page) {
    totalCount
    items {
      uid
      name
      referenceId
    }
  }
}
    ` as unknown as DocumentNode<GetCustomFieldCostCenterValuesQuery, GetCustomFieldCostCenterValuesQueryVariables>;
